import { noop } from 'lodash';

export const useSalesForcePush = () => {
  return {
    handleUpdatedSalesForcePushNotification: noop,
    handleNotificationPermissionOn: noop,
    verifyPushSalesforce: noop,
  };
};
